import React from 'react';
import { motion } from 'framer-motion';
import { Coffee } from 'lucide-react';
const varieties = [{
  name: 'Batian',
  description: "Kenya's modern variety, bred for disease resistance and exceptional cup quality."
}, {
  name: 'Ruiru 11',
  description: 'Compact and prolific, delivering rich, full-bodied flavors.'
}, {
  name: 'SL28',
  description: 'The legendary Kenyan variety, known for its bright citrus and berry notes.'
}, {
  name: 'SL34',
  description: 'Complex and sweet, with deep fruit and wine-like characteristics.'
}, {
  name: 'K7',
  description: 'Hardy and reliable, producing smooth, well-balanced cups.'
}, {
  name: 'Geisha',
  description: "The world's most prized variety, with delicate floral and tea-like elegance."
}];
export function VarietiesSection() {
  return <section id="varieties" className="py-20 md:py-32 bg-brand-charcoal text-white" data-id="element-146">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        <div className="text-center mb-16" data-id="element-148">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-149">
            <h2 className="text-4xl md:text-5xl font-display font-bold mb-4" data-id="element-150">
              Our Varieties
            </h2>
            <div className="h-1 w-24 bg-brand-red mx-auto mb-6" data-id="element-151"></div>
            <p className="text-gray-300 max-w-2xl mx-auto text-lg" data-id="element-152">
              Our farms grow world-class varieties chosen for their resilience,
              strong yields, and distinctive flavor profiles.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-153">
          {varieties.map((variety, index) => <motion.div key={variety.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-brand-black p-8 rounded-sm border border-gray-800 hover:border-brand-red transition-all duration-300 group" data-id="element-154">
              <div className="flex items-start justify-between mb-4" data-id="element-155">
                <h3 className="text-2xl font-display font-bold text-white group-hover:text-brand-red transition-colors" data-id="element-156">
                  {variety.name}
                </h3>
                <Coffee className="text-gray-600 group-hover:text-brand-red transition-colors" size={24} data-id="element-157" />
              </div>
              <p className="text-gray-400 leading-relaxed" data-id="element-158">
                {variety.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}